module.exports = __webpack_public_path__ + "static/media/folder-times.3b70a34b.svg";